<template>
    <div class="row justify-content-center align-items-center" style="min-height: 100vh">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">


                <div class="card-body px-lg-5 py-lg-5">


                    <form role="form">

                        <div class="mb-4 text-center">
                            <img class="img-fluid logo" src="../assets/logo.png">
                        </div>


                        <div class="mb-3 text-center text-danger" v-if="errorMessage"> {{errorMessage}}</div>


                        <base-input class="input-group-alternative mb-3"
                                    placeholder="ชื่อบัญชีผู้ใช้"
                                    addon-left-icon="fa fa-user"
                                    v-model="form.email">
                        </base-input>

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="รหัสผ่าน"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="form.password">
                        </base-input>


                        <base-button type="primary" class="" @click="signIn">
                            เข้าสู่ระบบ
                        </base-button>

                    </form>


                </div>
            </div>


        </div>
    </div>
</template>
<script>

    import {
        SIGN_IN,
    } from "../store/actions.type";
    import store from '../store';

    export default {
        name: 'login',
        data() {
            return {
                form: {
                    email: '',
                    password: ''
                },
                errorMessage: null
            }
        },
        methods: {
            signIn() {
                this.errorMessage = null;

                store.dispatch(SIGN_IN, {
                    username: this.form.email,
                    password: this.form.password,
                }).then(response => {
                    if (response.status === 'no') {
                        return this.errorMessage = 'ชื่อบัญชีผู้ใช้ หรือ รหัสผ่านไม่ถูกต้อง';
                    } else {
                        this.$router.push('/code');
                    }
                })

            },
        }

    }
</script>

<style scoped lang="scss">
    .logo {
        max-height: 120px;
    }
</style>
